<div class="relative inline-flex items-center">
    <i class="fas fa-clock pointer-events-none absolute left-3 z-10 text-[12px] text-muted"></i>
    <select [ngModel]="value" (ngModelChange)="onSelectChange($event)"
            class="h-9 cursor-pointer appearance-none rounded-full border border-line bg-white py-0 pl-8 pr-7 text-[13px] font-semibold text-ink shadow-sm transition-colors hover:border-brand-300 hover:bg-brand-50 focus:border-brand-400 focus:outline-none focus:ring-1 focus:ring-brand-300">
        <option value='1'>Intera Giornata</option>
        <option value='2'>Mattina</option>
        <option value='3'>Pomeriggio</option>
    </select>
    <i class="fas fa-chevron-down pointer-events-none absolute right-3 text-[10px] text-muted"></i>
</div>
